// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialUserState,
    UserSchema,
    FormFields,
} from "./User.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
const User = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [user, setUser] = useState(InitialUserState);
    const [formFields, setFormFields] = useState(FormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getGroups = async () => {
        const response = await get(EntityConstants.GROUPS, `max=all`);
        const data = await response.json();
        attachOptions("group_id", data);
        spinService.off();
    };

    const getUser = async (id) => {
        const response = await get(EntityConstants.USERS + `/${id}`);
        const data = await response.json();
        data.schools = data.schools.map(item => item.id);
        setUser(data);
        spinService.off();
    };

    const getSchoolsByCompanies = async () => {
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        const schools = formFields.find(item => item.name === "schools");
        if (schools.options.length === 0) {
            setUser(prevState => ({ ...prevState, schools: [] }));
            values.schools = [];
            return
        }
        spinService.on();
        const school_ids = schools.options.map(item => item.id);
        const filtered_school_ids = values.schools.filter(item => school_ids.includes(item));
        values.schools = filtered_school_ids;
        const isNewUser = values.id === undefined;
        const url = isNewUser ? EntityConstants.USERS : EntityConstants.USERS + `/${values.id}`;
        const method = isNewUser ? post : put;
        const response = await method(url, { user: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewUser ? MessageContants.SCHOOL_CREATED : MessageContants.SCHOOL_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        spinService.on();
        getGroups();
        getSchoolsByCompanies();
        if (id !== undefined) {
            getUser(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={user}
            validationSchema={UserSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.USER_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.USER_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

User.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default User;
